<template>
  <div class="crew_right">
    <div class="conInner">
      <div
        class="data"
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <h2 style="width: 500px">我的银行卡</h2>
        <div v-if="!$route.query.page" class="add-bank-card" @click="addCard">
          {{ isAddCard ? "返回我的银行卡" : "添加快捷支付卡" }}
        </div>
      </div>
      <!--温馨提示结束-->
      <div class="form_wrap white_box" style="margin-top: 20px">
        <div class="box" v-if="isAddCard">
          <div class="top"></div>
          <div class="body">
            <Form
              ref="formData"
              :model="formData"
              :rules="ruleCustom"
              :label-width="150"
              class="pwd-panel"
            >
              <FormItem label="银行" prop="bankName">
                <Select
                  v-model="formData.bankName"
                  @on-change="bankChange"
                  placeholder="请选择银行"
                  :transfer="true"
                  style="width: 200px; float: left"
                >
                  <Option v-for="item in bankList" :value="item" :key="item"
                    >{{ item }}
                  </Option>
                </Select>
              </FormItem>
              <FormItem label="卡号" prop="acctNo">
                <Input
                  v-model="formData.acctNo"
                  placeholder="银行卡号"
                  class="form-input"
                ></Input>
              </FormItem>
              <FormItem label="姓名" prop="acctName">
                <Input
                  v-model="formData.acctName"
                  :readonly="isHaveCard"
                  placeholder="持卡人姓名"
                  class="form-input"
                ></Input>
              </FormItem>
              <FormItem label="持卡人证件类型" prop="certType">
                <RadioGroup v-model="formData.certType" class="label">
                  <Radio :disabled="isHaveCard" label="P01">身份证</Radio>
                  <Radio :disabled="isHaveCard" label="P07">港澳证件</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem
                v-if="formData.certType == 'P01'"
                label="身份证"
                prop="certNo"
              >
                <Input
                  v-model="formData.certNo"
                  :readonly="isHaveCard"
                  class="form-input"
                  placeholder="持卡人身份证号"
                ></Input>
              </FormItem>
              <FormItem
                v-if="formData.certType == 'P07'"
                label="港澳证件"
                prop="gaNo"
              >
                <Input
                  v-model="formData.gaNo"
                  :readonly="isHaveCard"
                  class="form-input"
                  placeholder="持卡人证件号"
                ></Input>
              </FormItem>
              <FormItem label="">
                <div style="margin-left: 10px; color: #ed7108">
                  提醒：后续只支持绑定该持卡人的银行卡
                </div>
              </FormItem>
              <FormItem label="卡类型">
                <RadioGroup v-model="formData.acctType" class="label">
                  <Radio
                    label="debit"
                    v-show="
                      formData.bankName !== '中国银行' &&
                      formData.bankName !== '北京银行' &&
                      formData.bankName !== '交通银行' &&
                      formData.bankName !== '招商银行'
                    "
                    >借记卡/储蓄卡</Radio
                  >
                  <Radio
                    label="credit"
                    v-show="
                      formData.bankName !== '平安银行' &&
                      formData.bankName !== '邮储银行'
                    "
                    >贷记卡/信用卡</Radio
                  >
                </RadioGroup>
              </FormItem>
              <FormItem
                label="安全码"
                prop="cvv2"
                v-if="formData.acctType == 'credit'"
              >
                <Input
                  v-model="formData.cvv2"
                  placeholder="卡面背后三位数"
                  class="form-input"
                ></Input>
              </FormItem>
              <FormItem
                label="有效期"
                prop="expire"
                v-if="formData.acctType == 'credit'"
              >
                <Input
                  v-model="formData.expire"
                  placeholder="示例:01/20,输入0120"
                  class="form-input"
                ></Input>
              </FormItem>
              <FormItem label="手机号" prop="mobile">
                <Input
                  v-model="formData.mobile"
                  placeholder="银行预留手机号"
                  class="form-input"
                ></Input>
              </FormItem>
              <FormItem label="">
                <div style="margin-left: 10px">
                  <Checkbox v-model="formData.checked" size="large"></Checkbox
                  ><span>同意</span
                  ><span class="blue-text" @click="goPageHandle(1)">《快捷支付用户服务协议》</span
                  ><span class="blue-text" @click="goPageHandle(2)">《快捷支付隐私政策》</span
                  ><span class="blue-text" @click="goPageHandle(3)">《快捷支付服务协议》</span>
                </div>
              </FormItem>

              <FormItem>
                <Button @click="addCardHandle('formData')">验证并绑定</Button>
              </FormItem>
            </Form>
          </div>
          <div class="bottom" style="margin-top: -10px"></div>
        </div>
        <div class="box" v-else>
          <div class="body add-body">
            <div
              class="self-card-box"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <div class="title">
                <div style="display: flex; align-items: center">
                  <img :src="item.bankLogoUrl" alt="" width="26" />
                  <div style="margin-left: 4px">{{ item.bankName }}</div>
                  <div style="margin-left: 4px">
                    {{ item.acctType == "debit" ? "储蓄卡" : "信用卡" }}
                  </div>
                </div>
                <div class="set" @click="defaultCard(item)">设为默认卡</div>
              </div>
              <div class="main">
                <span style="font-size: 20px"
                  >**** **** **** {{ item.sliceCard }}</span
                >
                <span class="detail" @click="deletBindHandle(item)">解绑</span>
              </div>
              <div class="footer">
                <img src="../../../assets/images/yl.jpg" alt="" width="46" />
              </div>
            </div>
            <div class="add-card-box" @click="addCard">
              <div style="display: flex; height: 50px; align-items: center">
                <span style="font-size: 38px; margin-right: 6px">+</span>
                <span>添加银行卡</span>
              </div>
            </div>
          </div>
        </div>
        <div class="rr_bottom"></div>
      </div>
    </div>
    <bind-modal
      v-if="isShowBindModal"
      :isShowBindModal.sync="isShowBindModal"
      :origCusTraceNo="origCusTraceNo"
      @getCode="getCode"
      @bindSuccess="bindSuccess"
    ></bind-modal>
  </div>
</template>
<script>
import {
  sendBindCard,
  getCardList,
  unBind,
  defaultCard,
  getAcctName,
} from "api/user.js";
import { isIdCard } from "utils/tool";
import bindModal from "./bindPassWord";
import getBankcardinfo from "bankcardinfo";
export default {
  data() {
    const validateBankId = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择银行"));
      } else {
        callback();
      }
    };
    const validateSafetyCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入安全码"));
      } else {
        const patrn = /^\d{3}$/;
        if (!patrn.test(value)) {
          callback(new Error("请输入三位安全码数字"));
        } else {
          callback();
        }
      }
    };
    const validatePeriodValidity = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入有效期"));
      } else {
        const patrn = /^\d{4}$/;
        if (!patrn.test(value)) {
          callback(new Error("请输入四位有效期数字"));
        } else {
          callback();
        }
      }
    };
    const validateUserName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请填写持卡人姓名"));
      } else {
        const patrn = /^[\u4e00-\u9fa5]{2,6}$/;
        if (!patrn.test(value)) {
          callback(new Error("持卡人姓名必须为2-6个汉字"));
        } else {
          callback();
        }
      }
    };
    const validateBankCard = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请填写银行卡号"));
      } else {
        const patrn = /^(\w){15,21}$/;
        if (!patrn.test(value)) {
          callback(new Error("银行卡号必须为16-21位数字"));
        } else {
          callback();
        }
      }
    };
    const validateUserCard = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请填写身份证号"));
      } else {
        let data = value.toUpperCase();
        let flag = isIdCard(data);
        if (!flag) {
          callback(new Error("请填写正确的身份证号"));
        } else {
          callback();
        }
      }
    };
    const validateTel = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请填写手机号"));
      } else {
        let patrn = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!patrn.test(value)) {
          callback(new Error("请填写正确的手机号"));
        } else {
          callback();
        }
      }
    };

    const validateGoNo = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请填写证件号"));
      } else {
        let patrn = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,18}$/;
        if (!patrn.test(value)) {
          callback(new Error("请填写正确的证件号8-18位数字或字母"));
        } else {
          callback();
        }
      }
    };

    // /([0-9A-Z]{18})|(^\d{15}$)/
    return {
      isAddCard: false,
      bankList: [
        "工商银行",
        "中国银行",
        "中信银行",
        "上海银行",
        "光大银行",
        "民生银行",
        "北京银行",
        "平安银行",
        "交通银行",
        "招商银行",
        "广发银行",
        "建设银行",
        "浦发银行",
        "邮政储蓄银行",
      ],

      formData: {
        bankName: "",
        acctName: "",
        acctNo: "",
        certNo: "",
        cvv2: "",
        expire: "",
        acctType: "debit",
        certType: "P01",
        mobile: "",
        checked: false,
        gaNo: "",
      },
      ruleCustom: {
        bankName: [{ validator: validateBankId, trigger: "blur" }],
        acctName: [{ validator: validateUserName, trigger: "blur" }],
        certNo: [{ validator: validateUserCard, trigger: "blur" }],
        acctNo: [{ validator: validateBankCard, trigger: "blur" }],
        cvv2: [{ validator: validateSafetyCode, trigger: "blur" }],
        expire: [{ validator: validatePeriodValidity, trigger: "blur" }],
        mobile: [{ validator: validateTel, trigger: "blur" }],
        gaNo: [{ validator: validateGoNo, trigger: "blur" }],
      },
      isShowBindModal: false,
      origCusTraceNo: "",
      cardList: [],
      isHaveCard: false,
    };
  },
  components: {
    bindModal,
  },
  created() {
    if (this.$route.query.page) {
      this.isAddCard = true;
      this.getAcctName();
    } else {
      this.getCardList();
    }
  },
  methods: {
    goPageHandle(type) {
      if(type == 1) {
        window.open('/static/payUserAgreement.html')
      } else if(type == 2) {
        window.open('/static/privacyAgreement.html')
      } else {
        window.open('/static/payServiceAgreement.html')
      }
    },

    bankChange() {
      if (
        this.formData.bankName === "中国银行" ||
        this.formData.bankName === "北京银行" ||
        this.formData.bankName === "交通银行" ||
        this.formData.bankName === "招商银行"
      ) {
        this.formData.acctType = "credit";
      } else {
        this.formData.acctType = "debit";
      }
    },

    // 获取持卡人信息
    getAcctName() {
      getAcctName().then((res) => {
        if (res.data.acctName) {
          this.isHaveCard = true;
          this.formData.acctName = res.data.acctName;
          this.formData.certNo = res.data.certNo;
          this.formData.certType = res.data.certType;
          this.formData.gaNo = res.data.certNo;
        } else {
          this.isHaveCard = false;
        }
      });
    },

    // 获取卡列表
    getCardList() {
      getCardList().then((res) => {
        if (res.resCode == 1) {
          this.cardList = res.data;
          if (this.cardList.length > 0) {
            this.cardList.forEach((item) => {
              item.sliceCard = item.acctNo.slice(item.acctNo.length - 4);
            });
          }
        } else {
          this.$Message.error(res.resDesc);
        }
      });
    },

    // 解绑
    deletBindHandle(item) {
      this.$Modal.confirm({
        title: "",
        content: "确定要解绑此银行卡？",
        onOk: () => {
          unBind({ payToken: item.payToken }).then((res) => {
            if (res.resCode == 1) {
              this.$Message.success("解绑成功");
              this.getCardList();
            } else {
              this.$Message.error("解绑失败");
            }
          });
        },
        onCancel: () => {},
      });
    },

    addCard() {
      this.isAddCard = !this.isAddCard;
      if (this.isAddCard) {
        this.formData = {
          bankName: "",
          acctName: "",
          acctNo: "",
          certNo: "",
          cvv2: "",
          expire: "",
          acctType: "debit",
          certType: "P01",
          mobile: "",
          checked: false,
          gaNo: "",
        };
        this.getAcctName();
      } else {
        this.getCardList();
      }
    },

    // 绑定成功
    bindSuccess() {
      if (this.$route.query.page) {
        window.close();
      }
      this.isAddCard = false;
      this.getCardList();
    },

    // 设置默认卡
    defaultCard(item) {
      defaultCard({ id: item.id }).then((res) => {
        if (res.resCode === 1) {
          this.$Message.success("设置成功!");
          this.getCardList();
        } else {
          this.$Message.error("设置失败!");
        }
      });
    },

    getCode() {
      this.sendBindCard();
    },
    sendBindCard() {
      if (this.formData.gaNo) {
        this.formData.certNo = this.formData.gaNo;
      }
      sendBindCard({ ...this.formData }).then((res) => {
        if (res.resCode == 1) {
          this.isShowBindModal = true;
          this.origCusTraceNo = res.data;
        } else {
          this.$Message.error(res.resDesc);
        }
      });
    },
    // 修改支付密码
    addCardHandle(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.formData.acctNo) {
            let num = this.formData.acctNo - 0;
            //err是报错信息， data是未报错返回信息 ，num是银行账号
            getBankcardinfo.getBankBin(num, (err, data) => {
              console.log(data, "-----------");
              if (!err) {
                console.log("///", data);
                if (data.bankName.indexOf(this.formData.bankName) == -1) {
                  this.$Message.warning("您选择的银行与输入卡号不匹配，请确认");
                } else {
                  if (!this.formData.checked) {
                    this.$Message.warning("请勾选同意绑卡协议");
                  } else {
                    this.sendBindCard();
                  }
                }
              } else {
                console.log(err);
              }
            });
          }
        } else {
          console.log("校验失败");
        }
      });
    },
  },
};
</script>
<style scoped>
.pwd-panel {
  background-color: #fff;
}
.form-input {
  width: 200px;
  float: left;
}
.add-bank-card {
  height: 28px;
  line-height: 28px;
  background: #f10180;
  border-radius: 2px;
  padding: 0 10px;
  color: #fff;
  cursor: pointer;
}
.blue-text {
  color: #1e80ff;
  cursor: pointer;
}
.add-body {
  background: #fff;
  min-height: 600px;
  border: 1px solid #dbdbdb;
  border-radius: 8px;
  overflow: hidden;
  padding-bottom: 30px;
}
.add-card-box {
  width: 300px;
  height: 168px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #dbdbdb;
  float: left;
  margin-left: 50px;
  margin-top: 50px;
  cursor: pointer;
  font-size: 16px;
}
.self-card-box {
  width: 300px;
  height: 168px;
  border: 1px solid #dbdbdb;
  float: left;
  margin-left: 50px;
  margin-top: 50px;
  font-size: 16px;
}
.self-card-box .title {
  padding: 0 10px;
  height: 46px;
  border-bottom: 1px solid #dbdbdb;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.self-card-box .title .set {
  font-size: 12px;
  border: 1px solid #dbdbdb;
  padding: 2px 6px;
  border-radius: 4px;
  cursor: pointer;
}
.self-card-box .title .set:hover {
  background: #f10180;
  color: #fff;
  border: 1px solid #f10180;
}
.self-card-box .main {
  height: 80px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  justify-content: space-between;
}
.self-card-box .main .detail {
  font-size: 12px;
  border: 1px solid #dbdbdb;
  padding: 2px 6px;
  border-radius: 4px;
  cursor: pointer;
}
.self-card-box .main .detail:hover {
  background: #f10180;
  color: #fff;
  border: 1px solid #f10180;
}
.self-card-box .footer {
  height: 40px;
  background: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: end;
  border-top: 1px solid #dbdbdb;
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// bankCard.vue?078fa4f4